document.addEventListener("DOMContentLoaded", function() {
    const container = document.getElementById('video-container');
    if (!container) return;

    const iframeSrc = "https://www.youtube.com/embed/Dmsu8c_7v_M?si=JcTKzFLVyMvYjhvO&autoplay=1&mute=1&loop=1&playlist=Dmsu8c_7v_M&controls=0&modestbranding=1&showinfo=0";

    const loadIframe = () => {
        const iframe = document.createElement('iframe');
        iframe.width = "560";
        iframe.height = "315";
        iframe.src = iframeSrc;
        iframe.title = "Darido Olivenholz – Produktvideo";
        iframe.frameBorder = "0";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.referrerPolicy = "strict-origin-when-cross-origin";
        iframe.allowFullscreen = true;

        container.innerHTML = "";
        container.appendChild(iframe);
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadIframe();
                    observer.unobserve(entry.target);
                }
            });
        });
        observer.observe(container);
    } else {
        loadIframe();
    }
});
